import { gsap } from 'gsap'

export class Loading {
  constructor() {
    const page = document.getElementById('page')
    if (page.classList.contains('-index') === false) return
    const video = document.getElementById('js-kv_movie')

    const kvAnim = () => {
      const tl = gsap.timeline()
      tl.to('#page', {
        opacity: 1,
        duration: 1,
        onComplete: () => {
          video.play()
          let copy = document.querySelector('.p-index_kv__copy')
          copy.classList.add('is-act')
        },
      }).fromTo('.c-fixed_opencampus', { opacity: 0, x: 10 }, { opacity: 1, x: 0, delay: 2 })
    }

    window.addEventListener('load', () => {
      if (window.innerWidth < 768 && window.innerHeight > window.innerWidth) {
        video.src = './img/main/kv_movie_sp.mp4'
      } else {
        video.src = './img/main/kv_movie.mp4'
      }
      kvAnim()
    })
  }
}
